import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "m14.569 16.306 2.056-2.056H0v-1.583h16.625l-2.034-2.034 1.12-1.12 2.825 2.826a1.586 1.586 0 0 1 0 2.239l-2.848 2.847zM2.375 6.333H19V4.75H2.375l2.053-2.053-1.12-1.12L.464 4.423A1.58 1.58 0 0 0 0 5.542c0 .405.154.81.463 1.12l2.83 2.828 1.119-1.12z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "currentColor",
          d: "M19 0v19H0V0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }